import React, {  useEffect } from 'react';
import MetaTitle from '../components/MetaTitle';
import Header from './Header';
import "../assete/css/Language.css";
import language_pic_1 from "../assete/Add on service/language.jpeg";
import language_pic_2 from "../assete/Add on service/language-removebg-preview-min (1).png";
import language_pic_3 from "../assete/Add on service/language1.jpeg";
import Footer from './Footer';
import AOS from "aos";
import "aos/dist/aos.css";
import Scrolltop from './Scrolltop';
import language_vdo from "../assete/bannerimage/banner 9.jpg";
import Whatsapp from './Whatsapp';
const Language = () => {
    useEffect(() => {
        AOS.init({
            duration:600,
            delay:300
        });
      }, []);
     
  return (
   <>
     <MetaTitle title={"ADD-ON-Service | Language Correction | "} description="Find the best place to guide your research works at an affordable price. Visit Sea Sense Software Pvt. Ltd. for PhD guidance."
        keywords="PhD guidance in Marthandam |
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships |
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari |
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu |
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil |
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum |
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey |
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai |
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai |
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy |
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli |
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore |
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india |
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam |
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin |
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam |
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |"/>
   <Header/>
   <div className='language_main_div'>
   
   <img src={language_vdo} alt=""/>
      
        <div className="about_content">
    <h1>Language correction</h1>
    </div>
   </div>
   <div className='new_design_padding'>
   <div className='language_div_main'>
        <div className='language_div_main_1' data-aos="fade-down"data-aos-duration="2000">
            <h2>Language correction</h2>
            <p>Like many people, you probably took in the essential principles of syntax in school. What’s more, in the same way as other individuals, you’ve likely skipped quite a bit of what you realized. Is completing your sentences with a relational word an awful practice? Are there rigid regulations for when to utilize who, that, or which? Where do the comma and punctuation go?</p>
            <p> The importance of language correction in research work has never been greater than today.
            Language correction is becoming increasingly cognizant of the value of global collaboration as a source of competitive advantage. 
                Language persists as a definitive hindrance to aspirations of global synchronization. Specifically,
                  we audit the work concerning the language of the board. Also, we talk about the previously mentioned pattern of globalization, plot the elements of the language barrier and outline its outcomes.</p>
        </div>
        <div className='language_div_add_pic'>
            <img src={language_pic_1} alt="" data-aos="zoom-in"data-aos-duration="2000" />
        </div>
   </div>
   <div className='language_sub_div'>
    <div className='language_sub_div_1'>
        <img src={language_pic_2} alt="" data-aos="zoom-in"data-aos-duration="2000" />
    </div>
    <div className='language_sub_div_conts' data-aos="fade-down"data-aos-duration="2000">
        <h2>Professional Language Editors</h2>
        <p>Professional editors at Sea Sense Software are all highly trained writers, academics and graduate students, who have extensive editing experience. They are all native English speakers, and we expect them to graduate from a respected university and have the best academic credentials. Our editors who help with ESL editing have a lot of experience and help people with English grammar. They are professionals at resolving ESL grammatical errors, correcting spelling and providing world-class editing and proofreading services. Each of our editors is dedicated to helping you improve any work you submit. We set the time frame after talking with your instructors about your language-editing needs.</p>
    </div>
   </div>
   <div className='language_last_sub_div'>
    <div className='language_last_sub_div_1' data-aos="fade-down" data-aos-duration="2000">
        <h2>Our Language Correction includes</h2>
        <p>Subject – verb agreement</p>
        <p>Spelling mistakes</p>
        <p>Framing of sentences</p>
        <p>Appropriate usage of consecutive nouns</p>
        <p>Correctly spelled words  in the wrong context</p>
        <p>Since English is a difficult language, your work must be reviewed by someone who is both familiar with the subject and has excellent knowledge of English. As research is more complicated, a single mistake can change the meaning of a sentence, and inaccurate information can be difficult for the reader to understand.</p>
    </div>
    <div className='language_last_pic_add'>
        <img src={language_pic_3} alt="" data-aos="zoom-in"data-aos-duration="2000" />
    </div>
   </div>

   <div className='language_lats_main_conts' data-aos="fade-down"data-aos-duration="2000">
    <p>At Sea Sense, we review your entire document to ensure that even the most challenging papers on difficult subjects are completed to perfection. A good English document should have proper syntax – making sure the words and phrases, are correct spelling; grammar – structural use of clauses and words, checking common and uncommon phrases, sentence formation; punctuation – proper use of commas, periods, capital and lower-case letters.</p>
   </div>
   </div>
   <Whatsapp/>
   <Scrolltop/>
   <Footer/>
   </>
  )
}

export default Language